/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Form, FormikProps } from 'formik';
import { Grid } from '@material-ui/core';
import PageContainer from 'components/PageContainer';
import ActionButtonContainer, {
  TextAction,
} from 'components/ActionButtonsContainer';
import Title from 'components/Title';
import Button from 'components/Button';
import RestartLink from '../../form/RestartLink';
import AddressFields from '../../form/AddressFields';
import { useMarkdownTranslate, Trans } from 'hooks/useTranslate/useTranslate';
import { FormValues } from './BillingAddress';
import styles from './styles';
import GeolocationReason from 'components/GeolocationReason';

type PropTypes<T extends FormValues> = FormikProps<T> & {
  shouldGeolocate: boolean;
};

export default function BillingAddressView<T extends FormValues>(
  props: PropTypes<T>,
) {
  const { isValid, isSubmitting, shouldGeolocate } = props;
  const tMd = useMarkdownTranslate();

  return (
    <PageContainer maxWidth="md">
      <Form noValidate>
        <div css={styles.headingContainer}>
          <Title>{tMd('unified.application.billingAddress.title')}</Title>
        </div>
        <div css={styles.body}>
          {tMd('unified.application.billingAddress.subtitle')}
        </div>
        <Grid container direction="row" spacing={2}>
          <AddressFields {...props} />

          <Grid item xs={12}>
            {shouldGeolocate ? (
              <GeolocationReason translationKey="unified.application.billingAddress.geolocationReason" />
            ) : null}
          </Grid>

          <Grid item xs={12}>
            <ActionButtonContainer css={styles.actionsContainer}>
              <Button
                mobileFullWidth={true}
                id="billingAddressSubmit"
                type="submit"
                disabled={!isValid || isSubmitting}
                loading={isSubmitting}
              >
                {tMd('unified.application.billingAddress.continueButton')}
              </Button>
              <TextAction>
                <div css={styles.restartText}>
                  <Trans
                    i18nKey="unified.application.billingAddress.restartMessage"
                    components={[<RestartLink />]}
                  />
                </div>
              </TextAction>
            </ActionButtonContainer>
          </Grid>
        </Grid>
      </Form>
    </PageContainer>
  );
}
